// --- API Hooks ---
import { useGetFeaturedContentIdsQuery } from "../templates/ecommerce/featured/api/featuredApi";

// --- Custom Logic Hooks ---
import { useFeaturedContent } from "../templates/ecommerce/featured/hooks/useFeaturedContent";

// --- UI Components ---
import PageFeaturedProducts from "../templates/ecommerce/featured/components/Page/PageFeaturedProducts";
import PanelFeaturedProducts from "../templates/ecommerce/featured/components/Panel/PanelFeaturedProducts";
import PanelFeaturedCategories from "../templates/ecommerce/featured/components/Panel/PanelFeaturedCategories";
import PanelFeaturedTags from "../templates/ecommerce/featured/components/Panel/PanelFeaturedTags";

export const featured = {
  api: {
    useGetFeaturedContentIdsQuery,
  },
  hooks: {
    useFeaturedContent,
  },
  components: {
    PageFeaturedProducts,
    PanelFeaturedProducts,
    PanelFeaturedCategories,
    PanelFeaturedTags,
  },
};
